import React from 'react';
import { BrowserRouter, Navigate, Outlet, Route, Routes } from 'react-router-dom';
import { NewRelic } from '@vp/react-new-relic-browser';

import { useScreenClass } from '@vp/swan';
import { DevLandingPage } from './components/DevLandingPage';
import { PrimaryLayoutWithAuth } from './components/PrimaryLayoutWithAuth';
import { UploadAndPrint } from './components/UploadAndPrint/UploadAndPrint';
import { LOCALIZED_ROUTES } from './constants';
import { currentCulture } from './utils/cultureUtil';
import { getNewRelicScript } from './utils/getNewRelicScript';

const localizedRoute = LOCALIZED_ROUTES[currentCulture.toLowerCase()];
console.log(localizedRoute, currentCulture);
export interface LayoutProps {
  children?: React.ReactNode;
}

const APP_BASE_PATH = process.env.REACT_APP_ROUTER_BASENAME || '';

const Layout: React.FC<LayoutProps> = ({ children }: LayoutProps) => {
  const layout = (
    <>
      <NewRelic newRelicBrowserScript={getNewRelicScript(process.env.REACT_APP_NR_APP_ID)} />
      <PrimaryLayoutWithAuth forceSignIn={false} pageTitle="" header={null} footer={null}>
        {children}
        <Outlet />
      </PrimaryLayoutWithAuth>
    </>
  );

  return layout;
};

const Router: React.FC = () => {
  // const { trackingConfiguration } = useTrackingContext();
  // const embeddedChat = (
  //   <EmbeddedChat
  //     tenant="vistaprint"
  //     locale={currentCulture}
  //     feature="SnapIn"
  //     mode="persistChat"
  //     developmentMode={false}
  //     requestor={requestor}
  //     pageName={trackingConfiguration?.pageName}
  //     pageSection={trackingConfiguration?.pageSection}
  //     pageStage={trackingConfiguration?.pageStage}
  //   />
  // );
  const screenClass = useScreenClass();
  const isMobile = screenClass === 'xs';

  return (
    <BrowserRouter basename={APP_BASE_PATH}>
      <Routes>
        <Route path={localizedRoute} element={<Layout />}>
          <Route index element={<UploadAndPrint isMobile={isMobile} />} />
          {/* {embeddedChat} */}
        </Route>

        <Route
          path="/"
          element={
            process.env.NODE_ENV === 'development' ? (
              <DevLandingPage /> /* Wrap DevLandingPage in a Route component */
            ) : (
              <Navigate to={localizedRoute} />
            )
          }
        ></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
